<template>
  <div class="detail">
    <div><Back float="initial" /></div>
    <div class="title">{{ info.title }}</div>
    <div class="date">
      发布时间：{{ info.createDate | parseTime("{y}-{m}-{d} {h}:{i}:{s}") }}
    </div>
    <div class="content" v-html="info.content"></div>
  </div>
</template>

<script>
import Back from "../../components/Back.vue";
import { newsInfo } from "@/api/news";
export default {
  components: {
    Back
  },
  data() {
    return {
      id: undefined,
      info: undefined
    };
  },
  created() {
    this.id = this.$route.query.id;
    console.log(this.id);
    this.getInfo();
  },
  methods: {
    getInfo() {
      const { id } = this;
      newsInfo(id).then(res => {
        console.log(res);
        this.info = res.data.d;
      });
    }
  }
};
</script>

<style scoped lang="scss">
.detail {
  flex: 1;
  .title {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3a61b1;
    // line-height: 50px;
    text-align: center;
    margin-bottom: 38px;
  }
  .date {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #a2a2a2;
    margin-bottom: 23px;
    //   line-height: 41px;
  }
  .content {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #6e6e6e;
  }
}
</style>
<style>
.content img{
  max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/news/detail.vue